module.exports = __webpack_public_path__ + "static/assets/7467e9dcedc1f07b01431fd270a3f7f2.svg";